// src/components/Home/Profile/ProfileEditModal.js
import React, { useState } from "react";
import axios from "axios";
import "./ProfileEditModal.css";

export default function ProfileEditModal({
  user = {},
  isProfessional = false,
  onClose = () => {},
  onSave = () => {}
}) {
  const [form, setForm] = useState({
    name: user.name || "",
    email: user.email || "",
    phone: user.phone || "",
    bio: user.bio || "",
    city: user.city || "",
    state: user.state || "",
    experienceYears: user.experienceYears || "",
    profilePhoto: user.profilePhoto || user.avatar || "",
    skills: Array.isArray(user.skills)
      ? user.skills.join(", ")
      : ""
  });

  const [uploading, setUploading] = useState(false);

  const update = (k, v) =>
    setForm((prev) => ({ ...prev, [k]: v }));

  /* ================= PROFILE PHOTO UPLOAD ================= */
  const handleProfilePhotoUpload = async (file) => {
    if (!file) return;

    try {
      setUploading(true);

      const data = new FormData();
      data.append("profilePhoto", file);

      const res = await axios.post(
        "/api/users/profile-photo",
        data,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      update("profilePhoto", res.data.user.profilePhoto);

      const storedUser = JSON.parse(
        localStorage.getItem("civilink_user")
      );

      if (storedUser) {
        localStorage.setItem(
          "civilink_user",
          JSON.stringify({
            ...storedUser,
            profilePhoto: res.data.user.profilePhoto
          })
        );
      }
    } catch (err) {
      console.error("Profile photo upload failed", err);
      alert("Profile photo upload failed");
    } finally {
      setUploading(false);
    }
  };

 return (
  <div
  className="profile-edit-backdrop"
  onClick={() => {
    if (!form.phone?.trim()) {
      alert(
  "Please add your mobile number to complete your Civilink profile."
);
      return;
    }

    onClose();
  }}
>
    <div
      className="profile-edit-modal"
      onClick={(e) => e.stopPropagation()}
    >
      {/* ================= HEADER ================= */}

      <div className="profile-edit-header">

        <div>

          <h2>Edit Profile</h2>

          <p>
            Keep your Civilink profile updated.
          </p>

        </div>

      </div>

      {/* ================= BODY ================= */}

      <div className="profile-edit-body">

        {/* ================= PHOTO ================= */}

        <div className="profile-photo-section">

          <div className="profile-photo-wrapper">

            {form.profilePhoto ? (

              <img
                src={form.profilePhoto}
                alt="Profile"
                className="profile-photo-preview"
              />

            ) : (

              <div className="profile-photo-placeholder">

                {form.name
                  ? form.name.charAt(0).toUpperCase()
                  : "U"}

              </div>

            )}

          </div>

          <label className="upload-btn">

            {uploading
              ? "Uploading..."
              : "Change Profile Photo"}

            <input
              type="file"
              accept="image/*"
              hidden
              disabled={uploading}
              onChange={(e) =>
                handleProfilePhotoUpload(
                  e.target.files[0]
                )
              }
            />

          </label>

        </div>

        {/* ================= BASIC INFO ================= */}

        <div className="edit-section">

          <h3>Basic Information</h3>

          <div className="edit-grid">

            <div className="form-group">

              <label>Name</label>

              <input
                value={form.name}
                onChange={(e) =>
                  update("name", e.target.value)
                }
              />

            </div>

            <div className="form-group">

              <label>Email</label>

              <input
                value={form.email}
                onChange={(e) =>
                  update("email", e.target.value)
                }
              />

            </div>

            <div className="form-group">

  <label>
    Mobile Number <span className="required">*</span>
  </label>

  <input
    type="tel"
    placeholder="Enter your mobile number"
    value={form.phone}
    onChange={(e) => update("phone", e.target.value)}
    required
  />

  <small className="field-hint">
    Customers use this number to contact you through Civilink.
  </small>

</div>

          </div>

        </div>

        {/* ================= LOCATION ================= */}

        <div className="edit-section">

          <h3>Location</h3>

          <div className="edit-grid two-column">

            <div className="form-group">

              <label>City</label>

              <input
                value={form.city}
                placeholder="City"
                onChange={(e) =>
                  update("city", e.target.value)
                }
              />

            </div>

            <div className="form-group">

              <label>State</label>

              <input
                value={form.state}
                placeholder="State"
                onChange={(e) =>
                  update("state", e.target.value)
                }
              />

            </div>

          </div>

        </div>
                {/* ================= PROFESSIONAL INFO ================= */}

        {isProfessional && (
          <div className="edit-section">

            <h3>Professional Information</h3>

            <div className="edit-grid">

              <div className="form-group">

                <label>Experience (Years)</label>

                <input
                  type="number"
                  min="0"
                  value={form.experienceYears}
                  onChange={(e) =>
                    update(
                      "experienceYears",
                      e.target.value
                    )
                  }
                />

              </div>

              <div className="form-group full-width">

                <label>Skills</label>

                <input
                  placeholder="AutoCAD, Estimation, Site Management"
                  value={form.skills}
                  onChange={(e) =>
                    update(
                      "skills",
                      e.target.value
                    )
                  }
                />

                <small className="field-hint">
                  Separate multiple skills with commas.
                </small>

              </div>

            </div>

          </div>
        )}

        {/* ================= ABOUT ================= */}

        <div className="edit-section">

          <h3>About</h3>

          <div className="form-group">

            <label>Bio</label>

            <textarea
              rows={6}
              value={form.bio}
              onChange={(e) =>
                update("bio", e.target.value)
              }
            />

          </div>

        </div>

      </div>

      {/* ================= FOOTER ================= */}

      <div className="profile-edit-footer">

        <button
          className="profile-btn secondary"
          onClick={() => {
  if (!form.phone?.trim()) {
    alert("Please add your mobile number before continuing.");
    return;
  }

  onClose();
}}
        >
          Cancel
        </button>

        <button
          className="profile-btn primary"
          onClick={() => {

            const next = {

              ...user,

              ...form,

              experienceYears: isProfessional
                ? Number(form.experienceYears) || 0
                : user.experienceYears || 0,

              skills: isProfessional
                ? form.skills
                    ?.split(",")
                    .map((s) => s.trim())
                : user.skills || []

            };

            if (!form.phone?.trim()) {
  alert(
  "A mobile number is required to save your profile."
);
  return;
}

onSave(next);

          }}
        >
          Save Changes
        </button>

      </div>

    </div>

  </div>
);
}